module.exports = __webpack_public_path__ + "static/media/thumbnail.22ca1851.jpg";